module.exports = __webpack_public_path__ + "static/img/popupclickv.5d9b46e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/popupclickv.png
// module id = Od7Y
// module chunks = 1